import { ResponseDTO } from './response-dto';

export interface UpdateB2CResponseDTO extends ResponseDTO {}
